import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import CustomButton from '@/components/CustomButton'

export default function RechargeSuccess() {
    const { t } = useTranslation()
    const navigate = useNavigate()

    // 返回卡片主界面
    const handleBackToCard = useCallback(() => {
        navigate('/card', { replace: true })
    }, [navigate])

    return (
        <PageLayout>
            <Header
                leftChildren={<Back />}
            />

            <div className="flex-1 flex flex-col px-5">
                {/* 成功图标和文字 */}
                <div className="flex-1 flex flex-col items-center justify-center -mt-20">
                    {/* 成功图标 */}
                    <div className="mb-8">
                        <img src="/images/card-v2/recharge-success.svg" alt="success" />
                    </div>

                    {/* 成功标题 */}
                    <div className="text-7 font-semibold text-[#1D2129] mb-3">
                        {t('充值成功')}
                    </div>

                    {/* 成功描述 */}
                    <div className="text-base text-[#667085] text-center leading-relaxed">
                        {t('充值已到账，可前往卡片界面')}<br />
                        {t('查看资产')}
                    </div>
                </div>

                {/* 底部按钮 */}
                <div className="pb-8">
                    <CustomButton onClick={handleBackToCard}>
                        {t('返回主页')}
                    </CustomButton>
                </div>
            </div>
        </PageLayout>
    )
}

